
export default class SearchJobsCard {
    constructor(){

        let $post_container = jQuery('.post-container') ;

        if( $post_container.length > 0 ){

            $post_container.on( 'mouseenter mouseleave' , '.entry-card__link, .entry-card__title-link' , function(e){
                jQuery(this).closest( '.entry-card--offer' ).toggleClass('is--hovered');
            });


        }
    }

}